import { ComponentProps, useMemo } from 'react';
import { useCurrencySelection } from 'providers/currency-selection';
import { Currency } from 'types';

interface Props extends Omit<ComponentProps<'img'>, 'src' | 'width' | 'height'> {
  currency: Currency | string;
  size?: number;
}

export const CurrencyIcon = ({ currency, size = 40, alt = 'flag', ...rest }: Props) => {
  const { currencies } = useCurrencySelection();

  const svg = currencies.find((c) => c.isoCode === currency)?.icon;
  const src = useMemo(() => {
    if (!svg) return null;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }, [svg]);

  if (!src) return null;

  return <img src={src} alt={alt} width={size} height={size} {...rest} />;
};
